import React from "react";
var __jsx = React.createElement;
import { useStoreState } from "pullstate";
import Store from "../../utils/Store";
import Modal from "../common/Modal";
import { t } from "i18next";
import ExportData from ".";
import { trackEvent } from "../../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../../utils/mixpanelEvents";
var ExportDataModal = function ExportDataModal() {
  var _useStoreState = useStoreState(Store, function (s) {
      return {
        isVisible: s.isExportDataOpen
      };
    }),
    isVisible = _useStoreState.isVisible;
  var onCloseModal = function onCloseModal() {
    Store.update(function (s) {
      s.isExportDataOpen = false;
    });
  };
  var onClickCloseIcon = function onClickCloseIcon() {
    trackEvent(MIXPANEL_EVENTS.EXPORT_DATA_CANCEL, {
      type: "icon"
    });
    onCloseModal();
  };
  return /*#__PURE__*/React.createElement(Modal, {
    title: t("export_data"),
    onClose: onClickCloseIcon,
    show: isVisible,
    className: "flex flex-col w-full sm:w-7/12 lg:w-6/12 xl:w-4/12 h-[70%] overflow-hidden"
  }, /*#__PURE__*/React.createElement(ExportData, {
    onClose: onCloseModal
  }));
};
export default ExportDataModal;